<div class="carousel-container">
    <ngb-carousel #carousel>
        <ng-template ngbSlide *ngFor="let img of shelf.images">
          <img [src]="img.url" [alt]="img.alt" (click)="redirect(img.redirectUrl)" />
        </ng-template>
      </ngb-carousel>
      <div class="arrow-button next" (click)="next()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        </svg>
      </div>
      <div class="arrow-button prev" (click)="previous()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M14 6l1.41 1.41L9.83 12l4.58 4.59L14 18l-6-6z" />
        </svg>
      </div>
</div>